<div class="modal-header">
  <h4 class="modal-title">Sort And Download Owner Report</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="border-div margin0">
    <div class="floatinghead floatinghead-xs clearfix">
      <div class="row">
        <div class="col-sm-3 cf">
          <h2 class="mainhead d-flex"><span class="text">Offer Matrix</span></h2>
        </div>
        <div class="rightside clearfix">
          <div class="select-dropdown multiselectdesign margin-right-15 multi-check-dropdown pull-right">
            <!--<angular2-multiselect [data]="tableColumns" [(ngModel)]="selectedColumns" (ngModelChange)="CheckColumn($event)" [settings]="defaultTypeSettings"></angular2-multiselect>-->
            <mat-form-field>
               <mat-select placeholder="Select Columns" [(ngModel)]="selectedColumns" (ngModelChange)="CheckColumn($event)" multiple>
                <mat-select-trigger>
                  <span>Select Columns</span>
                </mat-select-trigger>
                @for (tableColumn of tableColumns; track tableColumn) {
                <mat-option [value]="tableColumn.id" class="multi-dropdown-item">{{tableColumn.name}}</mat-option>
                }
                <mat-option class="matoptionnodata" *ngIf="tableColumns.length === 0" disabled>
                  Nothing found...
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="table-responsive table-v-scroll table-fixed import-prospect-table" style="width: 100%">
        <table id="openro-data" class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
          <thead>
            <tr>
              <th [hidden]="hideColumn(1)">Offer Placed By</th>
              <th [hidden]="hideColumn(2)">Buyer Company</th>
              <th [hidden]="hideColumn(3)">Last Modified User</th>
              <th class="min-width-75" [hidden]="hideColumn(4)">Property<br />/Portfolio</th>
              <th [hidden]="hideColumn(5)">Offer Date</th>
              <th [hidden]="hideColumn(6)">Offer Price</th>
              <th [hidden]="hideColumn(7)">Offer Cap Rate</th>
              <th [hidden]="hideColumn(8)">Earnest Money Deposit</th>
              <th [hidden]="hideColumn(9)">DD Period (Days)</th>
              <th [hidden]="hideColumn(10)">HC Period (Days)</th>
              <th [hidden]="hideColumn(11)">Status</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let type of offerList;let p = index">
              <tr *ngIf="type.Key">
                <td class="sticky-left" [hidden]="hideColumn(1)">
                  <p class="whitespacenowrap">{{type.Key}}</p>
                </td>
                <td [hidden]="hideColumn(2)"></td>
                <td [hidden]="hideColumn(3)"></td>
                <td [hidden]="hideColumn(4)"></td>
                <td [hidden]="hideColumn(5)"></td>
                <td [hidden]="hideColumn(6)"></td>
                <td [hidden]="hideColumn(7)"></td>
                <td [hidden]="hideColumn(8)"></td>
                <td [hidden]="hideColumn(9)"></td>
                <td [hidden]="hideColumn(10)"></td>
                <td [hidden]="hideColumn(11)"></td>
              </tr>
              <ng-container *ngIf="type.Values.length > 0">
                <ng-container *ngFor="let offer of type.Values; let i= index;">
                  <tr>
                    <td class="whitespacenowrap tooptip-lg" [hidden]="hideColumn(1)">
                      <p *ngIf="isFromPortfolio">
                        <span *ngIf="(this._authenticationService.Principal()||this._authenticationService.Principal1031())&&!isPropertySeller">{{offer.LeadName}}</span>
                        <a *ngIf="(this._authenticationService.Principal()||this._authenticationService.Principal1031())&&isPropertySeller" href="#" target="_blank" routerLink="/offer-detail/{{offer.OfferDetailGuid}}" [queryParams]="{prevroute:'Property Details', link:router.url}">{{offer.LeadName}}</a>
                        <a *ngIf="(!this._authenticationService.Principal()&&!this._authenticationService.Principal1031())" href="#" target="_blank" routerLink="/offer-detail/{{offer.OfferDetailGuid}}" [queryParams]="{prevroute:'Property Details', link:router.url}">{{offer.LeadName}}</a>
                      </p>
                      <p *ngIf="!isFromPortfolio">
                        <a href="#" target="_blank" routerLink="/offer-detail/{{offer.OfferDetailGuid}}" [queryParams]="{prevroute:'Property Details', link:router.url}">{{offer.LeadName}}</a>
                      </p>
                      <p *ngIf="offer.BuyerName">on behalf of {{offer.BuyerName}}</p>
                      <p>({{getofferPlacedUserRole(offer.UserRole)}})</p>
                    </td>
                    <td [hidden]="hideColumn(2)">{{offer.TradeName ? offer.TradeName : '-'}}</td>
                    <td class="whitespacenowrap" [hidden]="hideColumn(3)">{{offer.LastModifiedUser}}</td>
                    <td [hidden]="hideColumn(4)">
                      <p class="d-flex whitespacenowrap">
                        {{offer.PropertyOrPortfolio}}
                      </p>
                    </td>
                    <td class="whitespacenowrap" [hidden]="hideColumn(5)"><p>{{convertUTCDateToLocalOfferDate(offer.OfferDate)| date:'MM/dd/yyyy'}}</p></td>
                    <td [hidden]="hideColumn(6)"><p class="whitespacenowrap">{{(offer.OfferPrice) ? '$ '+(offer.OfferPrice |number:0) : '-'}}</p></td>
                    <td [hidden]="hideColumn(7)"><p class="whitespacenowrap">{{(offer.CapRate) ? (offer.CapRate |number:0) +' %' : '-'}}</p></td>
                    <td [hidden]="hideColumn(8)"><p class="whitespacenowrap">{{(offer.EarnestMoneyDeposit) ? '$ '+(offer.EarnestMoneyDeposit |number:0) : '-'}}</p></td>
                    <td [hidden]="hideColumn(9)">{{(offer.DueDiligencePeriod) ? (offer.DueDiligencePeriod | number:0) : '-'}}</td>
                    <td [hidden]="hideColumn(10)">{{(offer.ClosingPeriod) ? (offer.ClosingPeriod | number:0) : '-'}}</td>
                    <td [hidden]="hideColumn(11)">{{offer.StatusName =='Cancelled' ? 'Canceled' :offer.StatusName}}<span *ngIf="offer.IsDraft" class="red">(Draft)</span></td>

                  </tr>
                </ng-container>

              </ng-container>
            </ng-container>

          </tbody>
          <tfoot>
            <tr *ngIf="unChangedofferList?.length == 0 ">
              <td colspan="17" class="odd no-data-available">
                <div class="nodata">
                  <i class="fa fa-exclamation-triangle icon"></i>
                  <p>No offers on this Property.</p>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

  </div>

  <app-prospect-preview [propertyId]="propertyId" (close)="onClose()" (save)="onSave($event)"></app-prospect-preview>

  <div class="form-group margin-bottom-30" [hidden]="!isShareReport">
    <label class="form-label">Email Address</label>
    <div class="textbox-date">
      <tag-input [(ngModel)]="mailIds" secondaryPlaceholder="Email Address" placeholder="+ Email IDs" [errorMessages]="errorMessages" [validators]="validators" [separatorKeyCodes]="keyCode"></tag-input>
      <h5 class="infotext">
        Use a comma or space to separate multiple email addresses
      </h5>
    </div>
  </div>

  <div class="text-right">
    <button type="button" class="btn btn-default btn-lg " (click)="onClose()">Cancel</button>
    <button class="btn btn-success btn-lg" *ngIf="!isShareReport" (click)="generateReport(propertyId)">Download Owner Report</button>
    <button class="btn btn-success btn-lg" *ngIf="isShareReport" (click)="shareReport(propertyId)">Share</button>
  </div>
</div>
